import { Box, Typography } from "@mui/material";
import NotFoundImage from "../../assets/images/NotFound.png";
import { colors } from "../../theme/palette";

const NotFound = () => {
  return (
    <Box sx={{ width: "100%", minWidth: "870px" }}>
      <Box
        sx={{
          maxWidth: " 312px !important",
          margin: "0 auto",
          width: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "90vh",
        }}
      >
        <img
          src={NotFoundImage}
          alt="Not found image"
          style={{
            width: "100%",
            maxHeight: "244px",
            aspectRatio: "78 / 61",
          }}
        />
        <Typography
          variant="h2"
          sx={{
            color: " #106048",
            fontSize: "35px",
            fontWeight: 700,
            lineHeight: "80px",
          }}
        >
          So Sorry!
        </Typography>
        <Typography
          variant="body1"
          component="p"
          sx={{
            color: colors.dark1000,
            fontSize: "20px",
            fontWeight: 400,
            lineHeight: "30px",
            textAlign: "center",
          }}
        >
          The page you are looking for cannot be found
        </Typography>
      </Box>
    </Box>
  );
};

export default NotFound;
